import gql from 'graphql-tag';

export default gql`
  query productsValidateForImportOrder($sort: [ProductSort], $filter: ProductFilterInput, $pagination: Pagination) {
    products(sort: $sort, filter: $filter, pagination: $pagination) {
      total
      totalPage
      data {
        id
        name
        nameVn
        nameLocal
        disabled
        internalCode
        productInfoByRegion {
          itemId
          regionCode
          price
          inStock
          exclusive
        }
      }
    }
  }
`;
